import { IconButton, Spacer, SvgCopy, SvgSearch, Tooltip } from '@loomhq/lens';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleIsTranscriptSearchOpen } from 'actions/shareVideo';
import { MOBILE_MAX_WIDTH } from 'constants/breakpoints';
import {
  TRANSCRIPTION_COPIED,
  TRANSCRIPTION_SEARCH_OPENED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';

import useMedia from 'hooks/useMedia';
import { selectUserIsOwner } from 'selectors/shareVideo';
import { selectTranscriptPhrases } from 'selectors/transcripts';
import { selectCurrentVideoId } from 'selectors/videoPlayer';

import { ROLLOUT_IN_TRANSCRIPT_SEARCH } from '../../../../../../shared/constants/featureFlag';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const COPY_TRANSCRIPT = 'Copy transcript';

export const SEARCH_TRANSCRIPT = 'Search transcript';

const TranscriptHeaderIcons = () => {
  const [copyTooltipContent, setCopyTooltipContent] = useState(COPY_TRANSCRIPT);
  const transcript = useSelector(selectTranscriptPhrases);
  const showTranscriptButtons =
    transcript && transcript.phrases && transcript.phrases.length > 0;
  const currentUserIsOwner = useSelector(selectUserIsOwner);
  const videoId = useSelector(selectCurrentVideoId);
  const dispatch = useDispatch();

  const onCopyButtonClicked = () => {
    setCopyTooltipContent('Copied to clipboard!');
    const { phrases } = transcript;

    if (phrases.length < 1) {
      return;
    }

    let text = '';

    phrases.forEach(row => {
      text += row.value + '\n';
    });

    analytics.track(TRANSCRIPTION_COPIED, {
      currentUserIsOwner,
      video_id: videoId,
    });

    copy(text);
  };

  const onSearchButtonClicked = () => {
    dispatch(toggleIsTranscriptSearchOpen(true));

    analytics.track(TRANSCRIPTION_SEARCH_OPENED, {
      currentUserIsOwner,
      video_id: videoId,
    });
  };
  const iconSize = useMedia(
    [`(max-width: ${MOBILE_MAX_WIDTH}px)`],
    ['medium'],
    'small'
  );

  return (
    <>
      {showTranscriptButtons && (
        <>
          <FeatureFlaggedComponent
            flag={ROLLOUT_IN_TRANSCRIPT_SEARCH}
            activationValues={[true]}
          >
            <Spacer right={1}>
              <Tooltip content={SEARCH_TRANSCRIPT} placement="bottomCenter">
                <IconButton
                  altText={SEARCH_TRANSCRIPT}
                  size={iconSize}
                  icon={<SvgSearch />}
                  onClick={onSearchButtonClicked}
                />
              </Tooltip>
            </Spacer>
          </FeatureFlaggedComponent>
          <Spacer right={1}>
            <Tooltip content={copyTooltipContent} placement="bottomCenter">
              <IconButton
                altText={COPY_TRANSCRIPT}
                size={iconSize}
                icon={<SvgCopy />}
                onClick={onCopyButtonClicked}
                onMouseEnter={() => setCopyTooltipContent(COPY_TRANSCRIPT)}
              />
            </Tooltip>
          </Spacer>
        </>
      )}
    </>
  );
};

export default TranscriptHeaderIcons;
